var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center"},[_c('div',[_c('j-alert',[_vm._v("You are currently offline.")]),_c('j-btn',{attrs:{"href":"/today"}},[_vm._v(" Try again ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }